import React, { useEffect, useRef } from 'react';

const isSensitive = (id) => id === 'RESET_PASSWORD' || id === 'EMAIL_VERIFICATION';
const isClubNotificationEmail = (id) => id === 'USER_VERIFIED' || id === 'MEMBER_APPLICATION';

const EmailTemplatePreviewModal = ({ isOpen, onClose, emailTemplate }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (emailTemplate && iframeRef.current) {
      const doc = iframeRef.current.contentDocument;
      if (doc) {
        doc.open();
        doc.write(emailTemplate.htmlBody || '');
        doc.close();
      }
    }
  }, [emailTemplate]);

  if (!isOpen || !emailTemplate) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl overflow-y-auto max-h-[90vh]">
        <h3 className="text-lg font-semibold mb-4">{emailTemplate.id}</h3>
        {isClubNotificationEmail(emailTemplate.id) && (
          <p className="mb-2">To: {emailTemplate.ccAddresses}</p>
        )}
        {!isSensitive(emailTemplate.id) && !isClubNotificationEmail(emailTemplate.id) && (
          <>
            <p className="mb-2">Cc: {emailTemplate.ccAddresses}</p>
            <p className="mb-2">Bcc: {emailTemplate.bccAddresses}</p>
          </>
        )}
        <p className="font-medium mb-2">Subject: {emailTemplate.subject}</p>
        <div className="border border-slate-300 rounded overflow-hidden" style={{ height: '450px' }}>
          <iframe
            ref={iframeRef}
            title="Email Preview"
            className="w-full h-full border-0"
          />
        </div>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplatePreviewModal;
